jQuery(function($) {
    // Asynchronously Load the map API 
    var script = document.createElement('script');
    script.src = "//maps.googleapis.com/maps/api/js?key=AIzaSyDDyeVtY-IHSjL3av5-dlDHqHG6bNkZL0o&callback=initialize";
    document.body.appendChild(script);
});

function initialize() {
    var map;
    var bounds = new google.maps.LatLngBounds();
    var mapOptions = {
        mapTypeId: 'roadmap'
    };
                    
    // Display a map on the page
    map = new google.maps.Map(document.getElementById("map_canvas"), mapOptions);
    map.setTilt(45);
        
    // Multiple Markers
    var markers = [
        ['Beds4U Henderson, Auckland', -36.883228, 174.634491],
        ['Beds4U Newmarket, Auckland', -36.867300, 174.775730],
     	['Beds4U Avondale, Auckland', -36.891410, 174.695840],
        ['Beds4U Silverdale', -36.613495, 174.681602],
        ['Beds4U Wairau Park', -36.7689906, 174.6538455],
        ['Beds4U Onehunga, Auckland', -36.9264134443851, 174.78221096662895],
        ['Beds4U Papakura, Auckland', -37.0626601, 174.9420575],
        ['Beds4U Thames', -37.1389735, 175.5396911],
        ['Beds4U Mt Maunganui', -37.678707, 176.2222290],
      	['Beds4U Tauranga', -37.673910, 176.164880],
        ['Beds4U Sylvia Park', -36.916478, 174.83765],
       	['Beds4U New Plymouth', -39.0552951, 174.0817192],
      	['Beds4U Palmerston North', -40.354830, 175.609670],
       	['Beds4U Levin', -40.6236391, 175.2847898],
      	['Beds4U Masterton', -40.949560, 175.661770],
      	['Beds4U Whangarei, Whangarei', -35.725520, 174.323310],
      	['Beds4U Rotorua', -38.136900, 176.240570],
     	['Beds4U Matamata', -37.803990, 175.770150],
        ['Beds4U Kerikeri', -35.210082, 173.916468],
        ['Beds4U Napier', -39.4888995, 176.9155167],
        ['Beds4U Hastings', -39.6389072, 176.8371374],
        ['Beds4U Waipukurau', -39.9953266, 176.5533832],
        ['Beds4U Dannevirke', -40.2094084, 176.0943287],
        ['Beds4U Awamutu', -38.008032838587674, 175.32287020000317],
        ['Beds4U Hamilton', -37.78874333310978, 175.2832107222392],
        ['Beds4U Tower Junction', -43.53733838119289, 172.60549044809696],
        ['Beds4U Papanui', -43.494048, 172.60857],
        ['Beds4U Thorndon', -41.272889253421646, 174.78259335760072],
        ['Beds4U Hornby', -43.544232, 172.526276],
        ['Beds4U Cambridge', -37.8946933, 175.4693404],
        ['Beds4U Lower Hutt', -41.2057662, 174.9056464],
    ];
        
    // Info Window Content
    var infoWindowContent = [
        ['<div class="info_content">' +
        '<h3>Beds4U Henderson, Auckland</h3>' +
        '<p></p>' +        '</div>'],

        ['<div class="info_content">' +
        '<h3>Beds4U Newmarket, Auckland</h3>' +
        '<p></p>' +
        '</div>'],

		['<div class="info_content">' +
        '<h3>Beds4U Avondale, Auckland</h3>' +
        '<p></p>' +        '</div>'],

        ['<div class="info_content">' +
        '<h3>Beds4U Silverdale</h3>' +
        '<p></p>' +
        '</div>'],

        ['<div class="info_content">' +
        '<h3>Beds4U Wairau Park</h3>' +
        '<p></p>' +
        '</div>'],
      
        ['<div class="info_content">' +
        '<h3>Beds4U Onehunga, Auckland</h3>' +
        '<p></p>' +
        '</div>'],
       
        ['<div class="info_content">' +
        '<h3>Beds4U Papakura, Auckland</h3>' +
        '<p></p>' +
        '</div>'],
            	
        ['<div class="info_content">' +
        '<h3>Beds4U Thames</h3>' +
        '<p></p>' +
        '</div>'],
      
      ['<div class="info_content">' +
        '<h3>Beds4U Mt Maunganui</h3>' +
        '<p></p>' +        
        '</div>'],

        ['<div class="info_content">' +
        '<h3>Beds4U Tauranga</h3>' +
        '<p></p>' +        
        '</div>'],

        ['<div class="info_content">' +
        '<h3>Beds4U Sylvia Park</h3>' +
        '<p></p>' +
        '</div>'],
       
        ['<div class="info_content">' +
        '<h3>Beds4U New Plymouth</h3>' +
        '<p></p>' +
        '</div>'],

        ['<div class="info_content">' +
        '<h3>Beds4U Palmerston North</h3>' +
        '<p></p>' +
        '</div>'],

        ['<div class="info_content">' +
        '<h3>Beds4U Levin</h3>' +
        '<p></p>' +        
        '</div>'],
             
        ['<div class="info_content">' +
        '<h3>Beds4U Masterton</h3>' +
        '<p></p>' +        
        '</div>'],

        ['<div class="info_content">' +
        '<h3>Beds4U Whangarei</h3>' +
        '<p></p>' +         
        '</div>'],

        ['<div class="info_content">' +
        '<h3>Beds4U Rotorua</h3>' +
        '<p></p>' +        
        '</div>'],
             
        ['<div class="info_content">' +
        '<h3>Beds4U Matamata</h3>' +
        '<p></p>' +         
        '</div>'],

        ['<div class="info_content">' +
        '<h3>Beds4U Kerikeri</h3>' +
        '<p></p>' +
        '</div>'],

        ['<div class="info_content">' +
        '<h3>Beds4U Napier</h3>' +
        '<p></p>' +
        '</div>'],

       ['<div class="info_content">' +
        '<h3>Beds4U Hastings</h3>' +
        '<p></p>' +
        '</div>'],

        ['<div class="info_content">' +
        '<h3>Beds4U Waipukurau</h3>' +
        '<p></p>' +
        '</div>'],

         ['<div class="info_content">' +
        '<h3>Beds4U Dannevirke</h3>' +
        '<p></p>' +
        '</div>'],

        ['<div class="info_content">' +
        '<h3>Beds4U Awamutu</h3>' +
        '<p></p>' +
        '</div>'],

        ['<div class="info_content">' +
        '<h3>Beds4U Hamilton</h3>' +
        '<p></p>' +
        '</div>'],

      ['<div class="info_content">' +
        '<h3>Beds4U Tower Junction</h3>' +
        '<p></p>' +
        '</div>'],

      ['<div class="info_content">' +
        '<h3>Beds4U Papanui</h3>' +
        '<p></p>' +
        '</div>'],
        
      ['<div class="info_content">' +
        '<h3>Beds4U Thorndon</h3>' +
        '<p></p>' +
        '</div>'],

        ['<div class="info_content">' +
        '<h3>Beds4U Hornby</h3>' +
        '<p></p>' +
        '</div>'],

        ['<div class="info_content">' +
        '<h3>Beds4U Cambridge</h3>' +
        '<p></p>' +
        '</div>'],

        ['<div class="info_content">' +
        '<h3>Beds4U Lower Hutt</h3>' +
        '<p></p>' +
        '</div>']
    ];
        
    // Display multiple markers on a map
    var infoWindow = new google.maps.InfoWindow(), marker, i;
    
    // Loop through our array of markers & place each one on the map  
    for( i = 0; i < markers.length; i++ ) {
        var position = new google.maps.LatLng(markers[i][1], markers[i][2]);
        bounds.extend(position);
        marker = new google.maps.Marker({
            position: position,
            map: map,
            title: markers[i][0]
        });
        
        // Allow each marker to have an info window    
        google.maps.event.addListener(marker, 'click', (function(marker, i) {
            return function() {
                infoWindow.setContent(infoWindowContent[i][0]);
                infoWindow.open(map, marker);
            }
        })(marker, i));

        // Automatically center the map fitting all markers on the screen
        map.fitBounds(bounds);
    }

    // Override our map zoom level once our fitBounds function runs (Make sure it only runs once)
    var boundsListener = google.maps.event.addListener((map), 'bounds_changed', function(event) {
        this.setZoom(5.5);
        google.maps.event.removeListener(boundsListener);
    });
    
}